var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert',{attrs:{"icon":_vm.icon,"icon-color":"#007DFF","text-color":"#0D3C61","color":"#007dff1a"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }